import { t } from 'i18next';
import * as yup from 'yup';

/**
 * The dialog reconciles the target `Company` in one of two ways:
 * - `existing`: connect to a `Company` selected from the typeahead.
 * - `new`: create a `Company` from the embedded `CompanyForm` (validated by its own
 *   `makeCompanyCreateSchema`), so only the picker/backfill fields are validated here.
 */
export const PROMOTE_TARGET_MODE = {
  existing: 'existing',
  new: 'new',
} as const;

export const promoteAccountSchema = yup.object().shape({
  mode: yup
    .string()
    .oneOf([PROMOTE_TARGET_MODE.existing, PROMOTE_TARGET_MODE.new])
    .required(),
  targetCompany: yup
    .object()
    .shape({
      label: yup.string().trim().required(),
      value: yup.string().trim().required(),
    })
    .nullable()
    .when('mode', {
      is: PROMOTE_TARGET_MODE.existing,
      then: (schema) =>
        schema.required(
          `${t('form_validation_errors.required', {
            field: t('form_fields.company'),
          })}`,
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
  backfill: yup.boolean().required(),
  // Optional external-system identity mappings stamped onto the source
  // (billing-identity) account. Prefilled from the source; when left blank they
  // are omitted from the payload so the backend preserves any existing value.
  accountingId: yup.string().trim().nullable().notRequired(),
  externalId: yup.string().trim().nullable().notRequired(),
});

export type PromoteAccountDto = yup.InferType<typeof promoteAccountSchema>;
